<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row dense class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="2">
          <v-select :disabled="$canRoute('commission-history-partner-tab') !== 1" solo :items="levelSlots" item-text="text" item-value="value" append-icon="mdi-chevron-down"
            label="All Level" class="custom-select" @change="handleLevelChange"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2" :md="$canRoute('commission-history-partner-tab') !== 1 ? 6 : 6" :lg="$canRoute('commission-history-partner-tab') !== 1 ? 4 : 2">
          <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here"
            placeholder="Search" single-line solo hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
                append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
                class="custom-select"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
                Cancel
              </v-btn>
              <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4">
          <ul class="commission-history-tablist">
            <li>
              <span>Total Lot:</span>
              <span>{{ commissionhistoryTotalLot?.toFixed(2) || "0.00" }}</span>
            </li>
            <li>
              <span>Total Trade:</span>
              <span>{{ commissionhistoryTotaltrade || "0" }}</span>
            </li>
            <li>
              <span>Commission:</span>
              <span>{{ commissionhistoryTotalCommission?.toFixed(2) || "0.00" }}</span>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2" class="text-center" v-if="$canRoute('commission-history-partner-tab') === 1">
          <v-btn tile elevation="0" class="mt-8 text-capitalize btn-account mb-0 mx-0" color="greenMain" @click="downloadExcel">
            <v-icon small left>mdi mdi-tray-arrow-down</v-icon>
            Download
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
        <v-data-table :headers="headers" :items="tableItems"
          :server-items-length="commissionhistorypagination?.total || 10" :options.sync="options" :loading="isLoading"
          :items-per-page="options.itemsPerPage" :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Rows per page:'
          }" @update:options="handleOptionsChange" disable-sort>
          <template v-slot:loading>
            <div class="d-flex align-center justify-center pa-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <span class="ml-2">Loading data...</span>
            </div>
          </template>
          <template v-slot:no-data>
            <div class="d-flex align-center justify-center pa-4">
              <v-icon color="secondary">mdi-information</v-icon>
              <span class="ml-2">No data found</span>
            </div>
          </template>
          <template v-slot:no-results>
            <div class="d-flex align-center justify-center pa-4">
              <v-icon color="secondary">mdi-magnify</v-icon>
              <span class="ml-2">No matching data found</span>
            </div>
          </template>
          <template v-slot:item.name="{ item }" v-if="$canRoute('create-new-user-account') === 1">
            <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.ib_code}`">
              {{ item.name }}
            </router-link>
          </template>
          <template v-slot:item.name="{ item }" v-else>
            {{ item.name }}
          </template>
          <template v-slot:item.level="{ item }">
            level {{ item.level }}
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PARTNERLIST__ACTIONS } from "@/store/action-types";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  name: 'CommissionHistoryTab',

  data() {
    return {
      search: "",
      searchTimeout: null,
      selectedDates: [],
      isLoading: false,
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      modal: false,
      dialog: false,
      headers: [
        { text: "SR No.", align: "start", value: "sl" },
        { text: "Name", value: "name" },
        { text: "Level", value: "level" },
        { text: "IB Code", value: "ib_code" },
        { text: "Position No.", value: "position_id" },
        { text: "Account No.", value: "account_no" },
        { text: "Symbol", value: "symbol" },
        { text: "Time", value: "to_date" },
        { text: "Volume", value: "volume" },
        { text: "Commission", value: "commission" },
      ]
    };
  },

  computed: {
    ...mapState("partnerlist", [
      "commissionhistory",
      "commissionhistorypagination",
      "commissionhistoryBusinessLevel",
      "commissionhistoryTotalCommission",
      "commissionhistoryTotalLot",
      "commissionhistoryTotaltrade",
    ]),

    tableItems() {
      return Array.isArray(this.commissionhistory) ? this.commissionhistory : [];
    },

    levelSlots() {
      const totalLevels = this.commissionhistoryBusinessLevel;
      if (!totalLevels) return [{ text: 'All Level', value: 'All' }];

      return [
        { text: 'All Level', value: 'All' },
        ...Array.from({ length: totalLevels }, (_, index) => ({
          text: `Level ${index + 1}`,
          value: index + 1
        }))
      ];
    },
  },

  methods: {
    ...mapActions("partnerlist", [PARTNERLIST__ACTIONS.COMMISSIONHISTORY]),

    async handleLevelChange(level) {
      this.options.page = 1;
      await this.fetchData(level);
    },

    downloadExcel() {
    if (!this.tableItems || this.tableItems.length === 0) {
      toast.error("No data available to download");
      return;
    }

    // Prepare data
    const data = this.tableItems.map((item, index) => ({
      "SR No.": index + 1,
      "Name": item.name,
      "Level": item.level,
      "IB Code": item.ib_code,
      "Position No.": item.position_id,
      "Account No.": item.account_no,
      "Symbol": item.symbol,
      "Time": item.to_date,
      "Volume": item.volume,
      "Commission": item.commission,
    }));
    //Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    //Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CommissionHistory");
    //Generate buffer
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    //Save file
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "CommissionHistory.xlsx");
  },

    async fetchData(level) {
      try {
        this.isLoading = true;
        let params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          parent_ib: this.$route.query.id,
          search: this.search,
        };

        if (level && level !== 'All') {
          params.level = level;
        }

        if (this.selectedDates?.length === 2) {
          params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
        }

        await this[PARTNERLIST__ACTIONS.COMMISSIONHISTORY](params);
        console.log('Data fetched:', this.commissionhistory); // Debug log
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async handleSearch() {
      this.options.page = 1;
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null;
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>